import { render, staticRenderFns } from "./NextBlock.vue?vue&type=template&id=cb169b54"
import script from "./NextBlock.vue?vue&type=script&lang=js"
export * from "./NextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports